export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-900 font-heading mb-3">
            关于小草影院
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            了解我们的故事与初心
          </p>
        </div>

        <div className="bg-background-50 rounded-xl p-8 md:p-10 border border-background-200/70">
          <div className="flex flex-col lg:flex-row items-start gap-8">
            <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center bg-primary-500 rounded-2xl">
              <i className="ri-movie-2-line text-white text-2xl"></i>
            </div>
            <div className="flex-1">
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                小草影院成立于2024年，是一个专注于为电影爱好者提供优质观影体验的在线平台。我们致力于汇集院线大片、最新上映电影以及动作片、喜剧电影等各类型影片，打造一个片库全面、更新及时、体验流畅的电影浏览平台。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                我们深知每一位电影爱好者对好片的渴望。小草影院的团队由一群热爱电影的小伙伴组成，每天精心筛选和整理优质影片资源，确保用户能够轻松找到自己想看的电影。无论是最新上映的热门院线大片，还是经典的动作片和喜剧电影，在小草影院都能快速找到。
              </p>
              <p className="text-sm text-foreground-700 leading-relaxed">
                目前，小草影院片库已收录超过10,000部影片，覆盖动作、喜剧、科幻、爱情、恐怖、动画、纪录等多个分类。我们坚持每日更新，不断丰富片库内容，只为让每一位访问小草影院的朋友都能发现属于自己的那部好电影。
              </p>

              <div className="mt-6 pt-6 border-t border-background-200/70 grid grid-cols-2 sm:grid-cols-4 gap-4">
                <div className="text-center">
                  <div className="text-xl font-bold text-primary-600 font-heading">10,000+</div>
                  <div className="text-xs text-foreground-500 mt-1">收录影片</div>
                </div>
                <div className="text-center">
                  <div className="text-xl font-bold text-accent-600 font-heading">30+</div>
                  <div className="text-xs text-foreground-500 mt-1">每日更新</div>
                </div>
                <div className="text-center">
                  <div className="text-xl font-bold text-secondary-600 font-heading">15+</div>
                  <div className="text-xs text-foreground-500 mt-1">电影分类</div>
                </div>
                <div className="text-center">
                  <div className="text-xl font-bold text-primary-600 font-heading">10万+</div>
                  <div className="text-xs text-foreground-500 mt-1">日活用户</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}